module.exports = __webpack_public_path__ + "img/xiaoshuxue.3e02b9bb.png";